const AD_SPACE_LENGTH = 3;
const AD_SPACE_HEIGHT_OFFSET = 230;

export function useLeafletLayout(leafletLength: Ref<number>, baseHeight: Ref<number>) {
	/**
	 * Calculate ad space dimensions for sidebar
	 */
	const adSpaces = computed(() => {
		const total = leafletLength.value;
		const count = Math.ceil(total / AD_SPACE_LENGTH);

		return Array.from({length: count}, (_, i) => {
			const groupSize = i === count - 1 && total % AD_SPACE_LENGTH !== 0
				? total % AD_SPACE_LENGTH
				: AD_SPACE_LENGTH;

			let height = (baseHeight.value * groupSize) + (8 * (groupSize - 1));

			if (i === 0) {
				height = Math.max(0, height - AD_SPACE_HEIGHT_OFFSET);
			}

			return {
				index: i,
				groupSize,
				height,
			};
		});
	});

	return {adSpaces};
}
